let prefix = '/api/industrialReveal';

function getIotDelayEvent(data) {
    return window.axios.get(prefix + '/index', {params:data});
}
function syncData() {
    return window.axios.get(prefix + '/sync');
}
function getMeasuringPoints() {
    return window.axios.get(prefix + '/measurepoint');
}
function getCatalogMeasurePoint() {
    return window.axios.get(prefix + '/measuringcatalog');
}
function setNewMeasurePoint(data){  
    return window.axios.post(prefix + '/newmeasurepoint', data);
}
function updateMeasurePoint(id, data){  
    return window.axios.put(prefix + '/updatemeasurepoint/' + id, data);
}
function getDelayMeasurePointInfo(id) {
    return window.axios.get(prefix + '/delaympcinfo/' + id);
}
function deleteDelayMeasurePoint(id) {
    return window.axios.delete(prefix + '/deletemeasurepoint/' + id);
}
export default {
    getIotDelayEvent, syncData, getMeasuringPoints, getCatalogMeasurePoint, setNewMeasurePoint, updateMeasurePoint, getDelayMeasurePointInfo, deleteDelayMeasurePoint
}